import { useAccountHealthSync } from '@/features/accounts/hooks/use-account-health-sync';

/**
 * Renders nothing; exists so the accounts feature can feed credential health
 * to the app chrome. Lives in the app layer because shared/components may not
 * import from features.
 */
export function AccountHealthBootstrap() {
  useAccountHealthSync();
  return null;
}
